import { Card, Typography, Grid, TextareaAutosize, Box } from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import styles from '../managePolicies/managePolicies.module.scss';
import { CustomEditIcon, CustomDeleteIcon, CommonButton } from '../../common/StyledComponents/StyledFields';
import VendorsForm from './vendorsForm';
import tablestyles from '../../devoteeService/devoteeService.module.scss';
import updateIcon from '../../../assets/svg/update_outline.svg';
import deleteIcon from '../../../assets/svg/delete_outline.svg';
import { apiRequest, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import ErrorPopup from '../../common/ErrorPopup';
import constants from '../../../config/constants.json';
import toast from 'react-hot-toast';
import Pagination from "../../common/pagination/pagination";

const DataEntryVendors = () => {
    const tableRef = useRef(null);
    const [isAdding, setIsAdding] = useState(false);
    const [vendorsList,setVendorsList] = useState([])
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleAddNewClick = () => {
        setIsAdding((pv) => !pv);
     };
    const vendorsDetails = [
        {
            "S.No": "1",
            "Vendor Name": "Title Name 123",
            "Address": "Hyderabad",
            "Date Last Modified": "13/11/2023",
            "Action": (
                <div>
                    <CustomEditIcon />
                    <CustomDeleteIcon />
                </div>
            ),
        },
        {
            "S.No": "2",
            "Vendor Name": "Title Name 456",
            "Address": "Hyderabad",
            "Date Last Modified": "13/11/2023",
            "Action": (
                <div>
                    <CustomEditIcon />
                    <CustomDeleteIcon />
                </div>
            ),
        },
    ]
    useEffect(() => {
        apiRequest({
            method: 'GET',
            endpoint: "/temple/vendors",
            params: {
                page: pageNumber - 1,
                size: 20,
                direction: "asc",
            },
            includeToken:true
        })
            .then((res) => {
                setTotalRecords(res.data.totalElements);
                setVendorsList(res.data.content);
            })
            .catch((err) => {
                console.log(err);
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                });
            });
    }, []);
    const tableData = () => {
        return (
           <Box>
              <table className={tablestyles.tableContainer}>
                 <thead>
                    <tr className={tablestyles.headerTableRow}>
                       <th className={tablestyles.tableHorizontal}>Vendor Name</th>
                       <th className={tablestyles.tableHorizontal}>Address</th>
                       <th className={tablestyles.tableHorizontal}>Action</th>
                    </tr>
                 </thead>
                 <tbody className={tablestyles.tableBody} id="searchData">
                    {vendorsList.map((row: any, id: number) => (
                       <tr key={id} className={tablestyles.tableRow}>
                          <td
                             className={tablestyles.tableDiagonal}
                             style={{
                                color: '#000',
                                fontWeight: 400,
                                textAlign: 'start',
                                paddingLeft: '21px',
                             }}
                          >
                             {row.vendorName}
                          </td>
                          <td
                             className={tablestyles.tableDiagonal}
                             style={{
                                color: '#000',
                                fontWeight: 400,
                                textAlign: 'start',
                             }}
                          >
                             {row.address}
                          </td>
                          <td
                             className={tablestyles.tableDiagonal}
                             style={{
                                fontWeight: 400,
                                color: '#000',
                                textAlign: 'start',
                             }}
                          >
                            {/* onClick={() => handleGetVastraPurposeData(row)} */}
                             <img src={updateIcon}  />
                             <img src={deleteIcon} />
                             {/* onClick={() => openConfirmPopUp1(row?.id)} */}
                          </td>
                       </tr>
                    ))}
                 </tbody>
              </table>
              {totalRecords > 20 ? (
                 <div
                    style={{
                       display: 'flex',
                       justifyContent: 'end',
                       marginRight: '10px',
                       marginTop: '3px',
                       float: 'right',
                    }}
                 >
                    <Pagination
                       items={totalRecords}
                       itemsPerPage={20}
                       setPageNumber={setPageNumber}
                       pageNumber={pageNumber}
                    />
                 </div>
              ) : (
                 ''
              )}
           </Box>
        );
     };

    const vendors = () => {
        return !isAdding ? (
            <div>
                <div className={styles.subContainer}>
                    <Typography className={styles.title}>Vendor</Typography>
                    <CommonButton className={styles.addnewButton} onClick={handleAddNewClick}>Add New</CommonButton>
                </div>
                <div className={styles.tableContainer}>
                 {tableData()}
                </div>
            </div>
        ) : (
            <>
            <VendorsForm/>
            </>
        )
    }
    return (
        <div style={{ display: "flex" }}>
            <div className={styles.mainContainer}>
                {vendors()}
            </div>
        </div>
    )
}

export default DataEntryVendors;
